/* eslint-disable no-unused-vars */
import Vue from 'vue';
import {
	userStatusTypes,
	designerAccountBrandTypes,
	sendUserTypes,
	sendUserTypeCode,
	targetUserTypes,
	targetUserTypeCode,
	sendMethodTypes,
	sendMethodTypeCode,
	sendPeriodTypes,
	sendPeriodTypeCode,
	bannerTypes,
	displayTargetUserTypes,
	displayPositionTypes,
	iconTypes,
	fontFamilyTypes,
	textAlignTypes,
	displayTimeTypes,
	displayTypes,
} from '@/js/types'; // 절대 경로 사용

export default {};

function isNull(text) {
	if (typeof text == 'undefined' || text == null) {
		return true;
	} else {
		return false;
	}
}

function toNumber(text) {
	if (isNull(text)) {
		return null;
	} else {
		return text * 1;
	}
}

function toText(number) {
	if (isNull(number)) {
		return null;
	} else {
		return number + '';
	}
}

function toSafeValue(value) {
	if (isNull(value)) {
		return null;
	} else {
		return value;
	}
}

function toBoolean(value) {
	if (isNull(value)) {
		return null;
	} else {
		return value === 'true' || value === true;
	}
}

export const models = {
	install(Vue) {
		Vue.prototype.$models = {
			UserModel: {
				create() {
					return {
						id: '',
						uid: '',
						phoneNum: '',
						email: '',
						name: '',
						nickname: '',
						userStatusType: userStatusTypes[0].code,
						userStatusTypeName: userStatusTypes[0].text,
						genderType: '',
						genderTypeName: '',
						ageType: '',
						ageTypeName: '',
						userType: '',
						userTypeName: '',
						birth: '',
						imageUrl: '',
						signUpMethodType: '',
						signUpMethodTypeName: '',
						pushToken: '',
						createAt: null,
						updateAt: null,
						lastLoginAt: null,
						favoriteIds: '',
						blockIds: '',
						isAgreePrivacy: false,
						isAgreeTerms: false,
						allowNoticeEventNotification: false,
						allowPushNotification: false,
						designerAuthStatus: '',
						designerAuthStatusType: '',
						designerAuthStatusTypeName: '',
						designerInfo: '',
						designerTags: '',
						designerPhotos: '',
						designerLicenseImageUrl: '',
						designerIsWork: false,
						designerOpenDays: '',
						designerOpenTime: '',
						designerCloseTime: '',
						designerAllCloseTime: '',
						designerAutoConfirmAppointment: false,
						designerAccountBrandType: designerAccountBrandTypes[0].code,
						designerAccountBrandTypeName: designerAccountBrandTypes[0].text,
						designerAccountNumber: '',
						locationAddress: '',
						locationLatitude: 0,
						locationLongitude: 0,
						locationDistance: 0,
						storeId: '',
						storeName: '',
						storeAddress: '',
						storePhoneNum: '',
					};
				},
				set(model) {
					return {
						id: toText(model.id),
						uid: toText(model.uid),
						phoneNum: toText(model.phoneNum),
						email: toText(model.email),
						name: toText(model.name),
						nickname: toText(model.nickname),
						userStatusType: toText(model.userStatusType),
						userStatusTypeName: toText(model.userStatusTypeName),
						genderType: toText(model.genderType),
						genderTypeName: toText(model.genderTypeName),
						ageType: toText(model.ageType),
						ageTypeName: toText(model.ageTypeName),
						userType: toText(model.userType),
						userTypeName: toText(model.userTypeName),
						birth: toText(model.birth),
						imageUrl: toText(model.imageUrl),
						signUpMethodType: toText(model.signUpMethodType),
						signUpMethodTypeName: toText(model.signUpMethodTypeName),
						pushToken: toText(model.pushToken),
						createAt: toSafeValue(model.createAt),
						updateAt: toSafeValue(model.updateAt),
						lastLoginAt: toSafeValue(model.lastLoginAt),
						favoriteIds: toSafeValue(model.favoriteIds),
						blockIds: toSafeValue(model.blockIds),
						isAgreePrivacy: toBoolean(model.isAgreePrivacy),
						isAgreeTerms: toBoolean(model.isAgreeTerms),
						allowNoticeEventNotification: toBoolean(model.allowNoticeEventNotification),
						allowPushNotification: toBoolean(model.allowPushNotification),
						designerAuthStatus: toText(model.designerAuthStatus),
						designerAuthStatusType: toText(model.designerAuthStatusType),
						designerAuthStatusTypeName: toText(model.designerAuthStatusTypeName),
						designerInfo: toText(model.designerInfo),
						designerTags: toText(model.designerTags),
						designerPhotos: toSafeValue(model.designerPhotos),
						designerLicenseImageUrl: toText(model.designerLicenseImageUrl),
						designerIsWork: toBoolean(model.designerIsWork),
						designerOpenDays: toSafeValue(model.designerOpenDays),
						designerOpenTime: toSafeValue(model.designerOpenTime),
						designerCloseTime: toSafeValue(model.designerCloseTime),
						designerAllCloseTime: toSafeValue(model.designerAllCloseTime),
						designerAutoConfirmAppointment: toBoolean(model.designerAutoConfirmAppointment),
						designerAccountBrandType: toText(model.designerAccountBrandType),
						designerAccountBrandTypeName: toText(model.designerAccountBrandTypeName),
						designerAccountNumber: toText(model.designerAccountNumber),
						locationAddress: toText(model.locationAddress),
						locationLatitude: toNumber(model.locationLatitude),
						locationLongitude: toNumber(model.locationLongitude),
						locationDistance: toNumber(model.locationDistance),
						storeId: toText(model.storeId),
						storeName: toText(model.storeName),
						storeAddress: toText(model.storeAddress),
						storePhoneNum: toText(model.storePhoneNum),
					};
				},
			},

			ReservationModel: {
				create() {
					return {
						id: '',
						reservationType: '',
						userUid: '',
						userName: '',
						storeName: '',
						reservationDay: null,
						startAt: null,
						endAt: null,
						price: '',
						hairCurType: '',
						hairTitle: '',
						designerUid: '',
						designerModel: null,
						designerName: '',
					};
				},
				set(model) {
					return {
						id: toText(model.id),
						reservationType: toText(model.reservationType),
						userUid: toText(model.userUid),
						userName: toText(model.userName),
						storeName: toText(model.storeName),
						reservationDay: toSafeValue(model.reservationDay),
						startAt: toSafeValue(model.startAt),
						endAt: toSafeValue(model.endAt),
						price: toText(model.price),
						hairCurType: toText(model.hairCurType),
						hairTitle: toText(model.hairTitle),
						designerUid: toText(model.designerUid),
						designerModel: toSafeValue(model.designerModel),
						designerName: toText(model.designerName),
					};
				},
			},

			MenuModel: {
				create() {
					return {
						id: '',
						title: '',
						designerId: '',
						price: '',
						percent: '',
						salePrice: '',
						jawPrice: '',
						shoulderPrice: '',
						chestPrice: '',
						waistPrice: '',
						hairInfo: '',
						hairTime: '',
						hairImageUrl: null,
						hairGenderType: '',
						isOpenMenu: null,
						createAt: null,
					};
				},
				set(model) {
					return {
						id: toText(model.id),
						title: toText(model.title),
						designerId: toText(model.designerId),
						price: toText(model.price),
						percent: toText(model.percent),
						salePrice: toText(model.salePrice),
						jawPrice: toText(model.jawPrice),
						shoulderPrice: toText(model.shoulderPrice),
						chestPrice: toText(model.chestPrice),
						waistPrice: toText(model.waistPrice),
						hairInfo: toText(model.hairInfo),
						hairTime: toText(model.hairTime),
						hairImageUrl: toSafeValue(model.hairImageUrl),
						hairGenderType: toText(model.hairGenderType),
						isOpenMenu: toSafeValue(model.isOpenMenu),
						createAt: toSafeValue(model.createAt),
					};
				},
			},

			StoreModel: {
				create() {
					return {
						id: '',
						address: '',
						addressDetail: null,
						contactNumber: '',
						createAt: null,
						description: '',
						gpsX: null,
						gpsY: null,
						isRepresentative: false,
						postCode: '',
						storeAddType: '', // 등록 유형 - 앱에서 관리. 추가매장인지 관리매장인지.
						storeAddTypeName: '', // 등록 유형명
						storeStatusType: '', // 매장 상태 유형
						storeStatusTypeName: '', // 매장 상태 유형명
						title: '',
					};
				},
				set(model) {
					return {
						id: toText(model.id),
						address: toText(model.address),
						addressDetail: toText(model.addressDetail),
						contactNumber: toText(model.contactNumber),
						createAt: toSafeValue(model.createAt),
						description: toText(model.description),
						gpsX: toSafeValue(model.gpsX),
						gpsY: toSafeValue(model.gpsY),
						isRepresentative: toBoolean(model.isRepresentative),
						postCode: toText(model.postCode),
						storeAddType: toText(model.storeAddType),
						storeAddTypeName: toText(model.storeAddTypeName),
						storeStatusType: toText(model.storeStatusType),
						storeStatusTypeName: toText(model.storeStatusTypeName),
						title: toText(model.title),
					};
				},
			},

			NotificationModel: {
				create() {
					return {
						id: '',
						message: '',
						createAt: new Date(),
						eventWhenClick: '',
						receiverUid: '',
						title: '',
						topic: '',
					};
				},
				set(model) {
					return {
						id: toText(model.id),
						message: toText(model.message),
						createAt: toSafeValue(model.createAt),
						eventWhenClick: toText(model.eventWhenClick),
						receiverUid: toText(model.receiverUid),
						title: toText(model.title),
						topic: toText(model.topic),
					};
				},
			},

			NotificationCenterModel: {
				create() {
					return {
						id: '',
						userName: '',
						desingerName: '',
						hairTitle: '',
						reserveDate: '',
						appointmentId: null,
						appointmentModel: null,
						createAt: new Date(),
						notificationCheck: false,
						notificationType: '',
						notificationTypeName: '',
						receiverUid: '',
						title: '',
						message: '',
						topic: '',
						eventWhenClick: '',
					};
				},
				set(model) {
					return {
						id: toText(model.id),
						userName: toText(model.userName),
						desingerName: toText(model.desingerName),
						hairTitle: toText(model.hairTitle),
						reserveDate: toText(model.reserveDate),
						appointmentId: toText(model.appointmentId),
						appointmentModel: toText(model.appointmentModel),
						createAt: toSafeValue(model.createAt),
						notificationCheck: toText(model.notificationCheck),
						notificationType: toText(model.notificationType),
						notificationTypeName: toText(model.notificationTypeName),
						receiverUid: toText(model.receiverUid),
						title: toText(model.title),
						message: toText(model.message),
						topic: toText(model.topic),
						eventWhenClick: toText(model.eventWhenClick),
					};
				},
			},

			AlertModel: {
				create() {
					return {
						id: '',
						message: '',
						sendUserType: sendUserTypeCode.manage.code, // 추후 시스템 확장을 위한 타입으로 그 전까지 매니저로 고정
						sendUserTypeName: sendUserTypeCode.manage.text, // 추후 시스템 확장을 위한 타입으로 그 전까지 매니저로 고정
						targetUserType: targetUserTypeCode.all.code, // 선택된 값
						targetUserTypeName: targetUserTypeCode.all.text, // 선택된 값의 이름
						sendMethodType: sendMethodTypeCode.push.code, // 선택된 값
						sendMethodTypeName: sendMethodTypeCode.push.text, // 선택된 값의 이름
						sendPeriodType: sendPeriodTypeCode.immediately.code, // 예약 전송을 위한 타입으로 그전까지 즉시 전송으로 고정
						sendPeriodTypeName: sendPeriodTypeCode.immediately.text, // 예약 전송을 위한 타입으로 그전까지 즉시 전송으로 고정
						appointmentAt: null,
						createAt: null,
						sendAt: null,
						successYn: null,
					};
				},
				set(model) {
					return {
						id: toText(model.id),
						message: toText(model.message),
						sendUserType: toText(model.sendUserType),
						sendUserTypeName: toText(model.sendUserTypeName),
						targetUserType: toText(model.targetUserType),
						targetUserTypeName: toText(model.targetUserTypeName),
						sendMethodType: toText(model.sendMethodType),
						sendMethodTypeName: toText(model.sendMethodTypeName),
						sendPeriodType: toText(model.sendPeriodType),
						sendPeriodTypeName: toText(model.sendPeriodTypeName),
						appointmentAt: toSafeValue(model.appointmentAt),
						createAt: toSafeValue(model.createAt),
						sendAt: toSafeValue(model.sendAt),
						successYn: toBoolean(model.successYn),
					};
				},
			},

			BannerModel: {
				create() {
					return {
						id: '',
						bannerType: bannerTypes[0].code,
						bannerTypeName: bannerTypes[0].text,
						displayPositionType: displayPositionTypes[0].code,
						displayPositionTypeName: displayPositionTypes[0].text,
						iconType: iconTypes[0].code,
						iconTypeName: iconTypes[0].text,
						title: '',
						content: '',
						layerHeight: 300,
						// fontSize: 13,
						// fontFamilyType: fontFamilyTypes[0].code,
						// fontFamilyTypeName: fontFamilyTypes[0].text,
						// textAlignType: textAlignTypes[0].code,
						// textAlignTypeName: textAlignTypes[0].text,
						// lineHeight: 1.3,
						displayTargetUserType: displayTargetUserTypes[0].code,
						displayTargetUserTypeName: displayTargetUserTypes[0].text,
						displayType: displayTypes[0].code,
						displayTypeName: displayTypes[0].text,
						sort: 1,
						displayTimeType: displayTimeTypes[0].code,
						displayTimeTypeName: displayTimeTypes[0].text,
						displayStartAt: new Date(),
						displayEndAt: new Date(),
						createAt: new Date(),
						updateAt: new Date(),
					};
				},
				set(model) {
					return {
						id: toText(model.id),
						bannerType: toText(model.bannerType),
						bannerTypeName: toText(model.bannerTypeName),
						displayPositionType: toText(model.displayPositionType),
						displayPositionTypeName: toText(model.displayPositionTypeName),
						iconType: toText(model.iconType),
						iconTypeName: toText(model.iconTypeName),
						title: toText(model.title),
						content: toText(model.content),
						layerHeight: toNumber(model.layerHeight),
						// fontSize: toSafeValue(model.fontSize),
						// fontFamilyType: toText(model.fontFamilyType),
						// fontFamilyTypeName: toText(model.fontFamilyTypeName),
						// textAlignType: toText(model.textAlignType),
						// textAlignTypeName: toText(model.textAlignTypeName),
						// lineHeight: toSafeValue(model.lineHeight),
						displayTargetUserType: toText(model.displayTargetUserType),
						displayTargetUserTypeName: toText(model.displayTargetUserTypeName),
						displayType: toText(model.displayType),
						displayTypeName: toText(model.displayTypeName),
						sort: toNumber(model.sort),
						displayTimeType: toText(model.displayTimeType),
						displayTimeTypeName: toText(model.displayTimeTypeName),
						displayStartAt: toSafeValue(model.displayStartAt),
						displayEndAt: toSafeValue(model.displayEndAt),
						createAt: toSafeValue(model.createAt),
						updateAt: toSafeValue(model.updateAt),
					};
				},
			},

			PushModel: {
				create() {
					return {
						id: '',
						createAt: new Date(),
						reservationId: '',
						title: '',
						message: '',
						sendAt: new Date(),
						eventWhenClick: '',
						receiveId: '',
						isSend: false,
					};
				},
				set(model) {
					return {
						id: toText(model.id),
						createAt: toSafeValue(model.createAt),
						reservationId: toText(model.reservationId),
						title: toText(model.title),
						message: toText(model.message),
						sendAt: toSafeValue(model.sendAt),
						eventWhenClick: toText(model.eventWhenClick),
						receiveId: toText(model.receiveId),
						isSend: toBoolean(model.isSend),
					};
				},
			},

			TreatmentModel: {
				create() {
					return {
						id: '',
						createAt: new Date(),
						updateAt: new Date(),
						level: 1,
						code: '',
						title: '',
						sort: 1,
						offerMinPrice: 0,
						useYn: true,
					};
				},
				set(model) {
					return {
						id: toText(model.id),
						createAt: toSafeValue(model.createAt),
						updateAt: toSafeValue(model.updateAt),
						level: toNumber(model.level),
						code: toText(model.code),
						title: toText(model.title),
						sort: toNumber(model.sort),
						offerMinPrice: toNumber(model.offerMinPrice),
						useYn: toBoolean(model.useYn),
					};
				},
			},

			TreatmentClassficationModel: {
				create() {
					return {
						id: '',
						createAt: new Date(),
						updateAt: new Date(),
						level: 1,
						levelCode1: '',
						levelTitle1: '',
						levelCode2: '',
						levelTitle2: '',
						levelCode3: '',
						levelTitle3: '',
					};
				},
				set(model) {
					return {
						id: toText(model.id),
						createAt: toSafeValue(model.createAt),
						updateAt: toSafeValue(model.updateAt),
						level: toNumber(model.level),
						levelCode1: toText(model.levelCode1),
						levelTitle1: toText(model.levelTitle1),
						levelCode2: toText(model.levelCode2),
						levelTitle2: toText(model.levelTitle2),
						levelCode3: toText(model.levelCode3),
						levelTitle3: toText(model.levelTitle3),
					};
				},
			},

			ConfigurationModel: {
				create() {
					return {
						id: null,
						allowMinmumBuildNumber: null,
						lastestVersion: null,
						aosAllowMinmumBuildNumber: null,
						aosLastestVersion: null,
						iosAllowMinmumBuildNumber: null,
						iosLastestVersion: null,
					};
				},
				set(model) {
					return {
						id: toText(model.id),
						allowMinmumBuildNumber: toText(model.allowMinmumBuildNumber),
						lastestVersion: toText(model.lastestVersion),
						aosAllowMinmumBuildNumber: toText(model.aosAllowMinmumBuildNumber),
						aosLastestVersion: toText(model.aosLastestVersion),
						iosAllowMinmumBuildNumber: toText(model.iosAllowMinmumBuildNumber),
						iosLastestVersion: toText(model.iosLastestVersion),
					};
				},
			},
		};
	},
};

Vue.use(models);
